import { ArrowLeftIcon } from 'lucide-react';

import React from 'react';

import { useTranslation } from '@splitfiesta/i18n';
import { Button } from '@splitfiesta/ui';

import { useBackNavigation } from '@/hooks/useBackNavigation';

interface BackButtonProps {
  /** Fallback URL if browser history is empty */
  fallbackUrl?: string;
  /** Custom button text (defaults to no text, just icon) */
  text?: string;
  /** Button variant */
  variant?: 'primary' | 'outline' | 'outline-solid' | 'ghost';
  /** Button size */
  size?: 'sm' | 'md' | 'lg';
  /** Additional class names */
  className?: string;
  /** Whether to show the arrow icon */
  showIcon?: boolean;
  /** Icon position */
  iconPosition?: 'left' | 'right';
}

export function BackButton({
  fallbackUrl,
  text,
  variant = 'ghost',
  size = 'sm',
  className = '',
  showIcon = true,
  iconPosition = 'left',
}: BackButtonProps) {
  const { t: _t } = useTranslation();
  const goBack = useBackNavigation(fallbackUrl);

  const icon = showIcon ? <ArrowLeftIcon className="w-4 h-4" /> : null;
  const buttonText = text !== undefined ? text : ''; // Default to empty string (no text)

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={goBack}
      leftIcon={iconPosition === 'left' ? icon : undefined}
      rightIcon={iconPosition === 'right' ? icon : undefined}
      data-testid="back-button"
    >
      {buttonText}
    </Button>
  );
}
